import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSeoHead, siteUrl } from '../components/website/SeoHead';
import { useCompanyBrand } from '../hooks/useCompanyBrand';

const seoCore = require('./seoCore');

// Applies registry SEO for every route; page-level SeoHead (CMS) runs after and may refine it.
export const RouteSeo = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const brand = useCompanyBrand();
  const s = useMemo(() => { seoCore.applyBrand(brand); return seoCore.seoFor(pathname, siteUrl()); }, [pathname, brand]);
  const seo = useMemo(() => ({ title: s.title, meta_description: s.description, og_image: s.image, canonical_url: s.canonical, no_index: s.noindex, no_follow: s.nofollow }), [s]);
  useSeoHead(seo, { path: seoCore.normalize(pathname) });

  useEffect(() => {
    const to = seoCore.redirectFor(pathname) || (pathname.length > 1 && pathname.endsWith('/') ? seoCore.normalize(pathname) : null);
    if (to) navigate(to + search, { replace: true });
  }, [pathname, search, navigate]);

  useEffect(() => {
    let el = document.head.querySelector('script[data-route-ld]');
    if (!s.schema) { el?.remove(); return; }
    if (!el) { el = document.createElement('script'); el.type = 'application/ld+json'; el.setAttribute('data-route-ld', '1'); document.head.appendChild(el); }
    el.textContent = JSON.stringify(s.schema);
  }, [s]);
  return null;
};
